export default __webpack_public_path__ + "static/media/apple_logo.b564e2ae.jpg";